// extracted by mini-css-extract-plugin
export default {"pageTitle":"hieS2XREYH1LwTKIxt8R","textMandatory":"tRPgEstpPvPLqwU0D79Q"};